var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",class:_vm.classes},[_vm._t("default",null,{"product":_vm.product,"loading":_vm.isLoading,"errors":_vm.err})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }